import styled from "styled-components";
import { getThemeFor } from "utils";

export const MenuWrapper = styled.div`
  position: relative;
`;

export const SelectWrapper = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
  flex-wrap: wrap;
  color: ${getThemeFor("$gray-7")};
  font-family: ${getThemeFor("$font-muli")};
  font-size: 16px;
  line-height: 22px;
  border: 1px solid
    ${props => (props.isActive ? props.theme["$blue"] : props.theme["$gray-3"])};
  border-radius: 6px;
  min-width: 160px;
  max-width: 400px;
  width: 100%;
`;

export const StyledInput = styled.input`
  display: flex;
  color: ${getThemeFor("$gray-7")};
  font-family: ${getThemeFor("$font-muli")};
  font-size: 14px;
  line-height: 22px;
  padding: 7px 14px;

  outline: none;
  border: none;
  border-radius: 6px;

  min-width: 60px;
  max-width: 400px;

  &[readonly],
  &[disabled] {
    background-color: ${getThemeFor("$gray-1")};
  }

  &[disabled] {
    color: ${getThemeFor("$gray-4")};
  }

  &::placeholder {
    color: ${getThemeFor("$gray-4")};
  }

  &:focus {
    border-color: ${getThemeFor("$blue")};
  }
`;

export const Pill = styled.span`
  display: flex;
  margin: 2px 2px;
  padding: 4px;
  border-radius: 4px;
  background-color: ${getThemeFor("$gray-1")};
  border: 1px solid ${getThemeFor("$gray-3")};
  overflow-x: hidden;
  &:hover {
    cursor: pointer;
    background-color: ${getThemeFor("$dark-tint-10")};
  }
`;

export const Menu = styled.ul`
  background-color: white;
  position: absolute;
  padding: 16px 0;
  top: calc(100%);
  margin-top: 0px;
  list-style: none;
  border-radius: 4px;
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  box-shadow: ${getThemeFor("$box-shadow-3")};
  z-index: 3;
  min-width: 200px;
  width: auto;
  max-width: 400px;
  padding: 0;
  cursor: default;
`;

export const StyledLi = styled.li`
  display: block;
  position: relative;
  padding: 7px 24px 6px;
  line-height: 26px;
  font-size: ${getThemeFor("$font-size-base")};
  white-space: nowrap;
  cursor: pointer;
  text-decoration: none;
  background-color: ${props => (props.isActive ? props.theme["$gray-2"] : "")};
  &:hover {
    cursor: pointer;
  }
  &:hover,
  &:focus,
  &:active {
    background-color: ${getThemeFor("$gray-2")};
  }
`;
